import { z } from 'zod';
import { TFunction } from 'i18next';
import { getCountryOptions } from '../../api/types/scheduling-settings.types';

/**
 * Validation schema for scheduling settings form.
 * Validates work hours, weekend/holiday settings with proper constraints.
 */
const MINIMUM_WORKDAY_MINUTES = 60;
const VALID_COUNTRY_CODES = getCountryOptions().map((c) => c.code) as [string, ...string[]];

export const createSchedulingSettingsFormSchema = (t: TFunction) => z.object({
  // Work hours
  workdayStartHour: z.number().int().min(0).max(23),
  workdayStartMinute: z.number().int().min(0).max(59),
  workdayEndHour: z.number().int().min(0).max(23),
  workdayEndMinute: z.number().int().min(0).max(59),

  // Weekend and holiday settings
  skipWeekends: z.boolean(),
  skipHolidays: z.boolean(),
  holidayCountryCode: z.enum(VALID_COUNTRY_CODES),
}).refine(
  (data) => {
    const startMinutes = data.workdayStartHour * 60 + data.workdayStartMinute;
    const endMinutes = data.workdayEndHour * 60 + data.workdayEndMinute;
    const workdayLength = endMinutes - startMinutes;
    return workdayLength >= MINIMUM_WORKDAY_MINUTES;
  },
  {
    message: t('scheduling.form.validation.workDayMinimum'),
    path: ['workdayEndHour'],
  }
);

export type SchedulingSettingsFormValues = z.infer<
  ReturnType<typeof createSchedulingSettingsFormSchema>
>;
